var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-start mb-5" },
            [
              _c(
                "b-col",
                { attrs: { cols: "4", sm: "3", md: "2", xl: "1" } },
                [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("ssh-form-global", {
            attrs: { mode: _vm.mode, id: _vm.id, readonly: !_vm.isEditable },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }